export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_inspectionNo') || '辅料检验单号',
    field: 'inspectionNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_status') || '状态',
    field: 'status',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('table_label_auditResultType') || '审核结果',
    field: 'auditResultType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'displayAuditResultType'
    }
  },
  {
    title: that.$l('table_label_purchaseMaterialCode') || '物料编码/名称',
    field: 'purchaseMaterialCode',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'purchaseMaterial'
    }
  },
  {
    title: that.$l('table_label_cd') || 'CD#',
    field: 'cd',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_materialDesc') || '规格型号',
    field: 'materialDesc',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_materialRequirement') || '材质要求',
    field: 'materialRequirement',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_arrivalDate') || '实际到料日期',
    field: 'arrivalDate',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_totalArrivalQuantity') || '来料数量',
    field: 'totalArrivalQuantity',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_whReceiverNames') || '仓库收货人员',
    field: 'whReceiverNames',
    width: 150,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_inspectionDate') || '检验日期',
    field: 'inspectionDate',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_reporterNames') || '质检员',
    field: 'reporterNames',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'reporterNames' }
  },
  {
    title: that.$l('table_label_inspectionResult') || '检验结果',
    field: 'v_inspectionResult',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_totalInspectQuantity') || '抽检数量',
    field: 'totalInspectQuantity',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_totalQualifiedQuantity') || '合格数量',
    field: 'totalQualifiedQuantity',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_totalDefectiveQuantity') || '不良数量',
    field: 'totalDefectiveQuantity',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_qtyUnit') || '单位',
    field: 'qtyUnit',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_totalQualifiedRate') || '合格率',
    field: 'totalQualifiedRate',
    width: 110,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const totalQualifiedRate = row.totalQualifiedRate || '0'
      return `${totalQualifiedRate}%`
    }
  },
  {
    title: that.$l('table_label_purchaseMaterialNo') || '采购单号',
    field: 'purchaseMaterialNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_originOrderNo') || '源头订单号',
    field: 'originOrderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_scmName') || '供应商',
    field: 'scmName',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_buyerName') || '采购员',
    field: 'buyerName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    slots: { default: 'createInfo' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    slots: { default: 'modifyInfo' }
  }
]
